// extracted by mini-css-extract-plugin
export default {"infoContentContainer":"style_infoContentContainer__qvG3b","infoContent":"style_infoContent__GwxmZ"};